import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getListNotifyAPI } from "../../../api/notify";

// First, create the thunk
export const fetchNotify = createAsyncThunk(
  "notify/fetchNotify",
  async ({ query }: { query: string }) => {
    try {
      const response = await getListNotifyAPI(query);
      return response.data;
    } catch (error) {
      
    }
  }
);

const initialState: any = {
  isFetching: true,
  pagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  },
  result: [],
};

export const notify = createSlice({
  name: "notify",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchNotify.pending, (state) => {
      state.isFetching = true;
    });

    builder.addCase(fetchNotify.rejected, (state) => {
      state.isFetching = false;
    });

    builder.addCase(fetchNotify.fulfilled, (state, action) => {
      state.isFetching = false;
      state.pagination = action.payload?.pagination;
      state.result = action.payload?.data;
    });
  },
});

export const {} = notify.actions;

export default notify.reducer;
